import { resolveUrl } from '@shared/lib/resolve-url'

export const getAmplitudeLink = (deviceId: string | null): string | null =>
  resolveUrl('https://app.amplitude.com/analytics/skelar/project/472284/search/[deviceId]', { deviceId })

export const getClarityUrl = (projectId: string | null): string | null =>
  resolveUrl('https://clarity.microsoft.com/projects/view/[projectId]/impressions?date=Last%203%20days', { projectId })

export const getRecruiteeUrl = (offerSlug: string): string | null =>
  resolveUrl('https://brighterly.recruitee.com/api/offers/[offerSlug]/candidates', { offerSlug })

export const getRecruiteeSourcesUrl = (companyId: string, candidateId: string): string | null =>
  resolveUrl('https://api.recruitee.com/c/[companyId]/candidates/[candidateId]/sources', { companyId, candidateId })

export const getRecruiteeFieldsUrl = (companyId: string, candidateId: string): string | null =>
  resolveUrl('https://api.recruitee.com/c/[companyId]/custom_fields/candidates/[candidateId]/fields', { companyId, candidateId })
